import React, { useEffect, useState } from "react";
import fundIcon from "../assets/images/fund.svg";
import pensionfundsIcon from "../assets/images/pension-funds.svg";
const FundsCard = ({ count, cardArrayData, from, indexKey }) => {
  const [balanceDataFields, setBalanceDataFields] = useState([]);
  const [fundsData, setFundsData] = useState([
    { icon: fundIcon, text: cardArrayData[0].title, key: "field_1" },
    { icon: pensionfundsIcon, text: cardArrayData[1].title, key: "field_2" },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      const processedData = [
        {
          field: `${
            indexKey === 0 && from != "loan" ? "₪" : ""
          }${
            indexKey === 0 && from === "loan" ? "%" : ""
          }${(cardArrayData[0]?.RIBIT).toFixed(2)}`,
        },
        { field: `₪${(cardArrayData[1]?.SCHUM_HECHZER_TKUFATI).toFixed(2)}` },
      ];
      console.log('processedData', from);
      
      setBalanceDataFields(processedData);
    };
    fetchData();
  }, []);

  return (
    <div className="funds-cards d-flex flex-wrap gap-16">
      {fundsData.slice(0, count).map((fund, index) => (
        <div key={index} className="cards-box white-bg radius-16">
          <div className="icon d-flex align-items-center justify-content-center white-bg radius-100">
            <img src={fund.icon} alt="Icon" />
          </div>
          <div className="content">
            <p>{fund.text}</p>
            <h3>
              {(balanceDataFields && balanceDataFields.length>0)
                ? balanceDataFields[index]?.field &&
                   `${
                      balanceDataFields[index].field.includes("₪") ? "₪" : ""
                    }${parseFloat(
                      balanceDataFields[index].field.replace(/[₪%]/g, "")
                    ).toLocaleString("en-US", { maximumFractionDigits: 2 })}${
                      !balanceDataFields[index].field.includes("₪") ? "%" : ""
                    }`
                  : "0"}
            </h3>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FundsCard;
